var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"search",attrs:{"aria-label":"Search for word","type":"text","id":"search","name":"textfield","placeholder":"Search for words.."},on:{"input":_vm.updateSearchFilter}})}
var staticRenderFns = []

export { render, staticRenderFns }